import React, { useEffect } from "react";
import styled from "styled-components";
import spike_planted from '../../assets/spike_planted.svg';
import death from '../../assets/death.svg';
import kill from '../../assets/kill.svg';
import "react-spring-bottom-sheet/dist/style.css";

const Container = styled.div`
    background: #1C1F33;
    border-radius: 12px;
    margin: 0px 3px;
    border: ${props => props.active ? "1px solid #4A7DFF;" : "1px solid transparent;"};
    padding: 8px;
    min-width: 114px;
`;

const Title = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 4px;
    margin-bottom: 10px;
`;

const Icon = ({icon, count}) => {
    return (
        <div style={{display: 'flex', marginRight: 8, marginTop: 6}}>
            <img src={icon} />
            {count > 0 && <span style={{marginLeft: 4}}>{count}</span>}
        </div>
    );
}

export default function RoundCard(props) {
  return (    
    <Container onClick={() => {
        props.onClick();
        window.analytics.track('round_card_clicked', {
            from: 'glip-list-page',
            round: `${props.round}`
        })
    }}>
        <Title>Round {props.round}</Title>
        <IconWrapper>
            {props.kills > 0 && <Icon icon={kill} count={props.kills}/>}
            {props.death && <Icon icon={death} />}
            {props.spike_planted && <Icon icon={spike_planted} />}
        </IconWrapper>
    </Container>      
  );
}
